import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";
import { RJToken } from "./RJToken";


export class VariableExpression extends RJExpressionNode
{
  _variableName:RJToken;

  constructor( parser:RJParser, range:SourceRange = null )
  {
    super( parser, RJExpressionNodeType.VARIABLE, range );
  }

  setVariable( name:RJToken )
  {
    this._variableName = name;
  }

  cloneNode():VariableExpression
  {
    let clone = new VariableExpression( this.parser, this.sourceRange );
    clone.setVariable( this._variableName.cloneNode() );    
    return clone;
  }

  static readonly constantTypeAttribute = new ElementAttribute( "constant-type" );

  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    element.appendChild( document.createTextNode( this._variableName.match + "" ) );

    return element;
  }
}